import { Button } from 'antd';
import { EyeInvisibleOutlined, EyeOutlined, DeleteOutlined } from '@ant-design/icons';
import { createFileRoute, useNavigate, useParams } from '@tanstack/react-router';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import calendar from 'dayjs/plugin/calendar';
import { useTranslation } from 'react-i18next';

import { useThreadBulkActions } from '@/components/threads';
import { ThreadDetailView } from '@/components/threads/ThreadDetailView';
import { normalizeThreadKey } from '@/components/threads/utils';
import { DeleteEntityModal } from '@/components/shared';
import { useThreadDetail } from '@/hooks/threads/useThreadDetail';

dayjs.extend(relativeTime);
dayjs.extend(calendar);

export const Route = createFileRoute('/manage/threads/$threadId')({
  component: ThreadDetailComponent
});

function ThreadDetailComponent() {
  const { t } = useTranslation('manage');
  const { threadId } = useParams({ from: '/manage/threads/$threadId' });
  const threadKey = normalizeThreadKey(threadId);
  const detail = useThreadDetail(threadKey, { kind: 'manage' });
  const { thread } = detail;
  const navigate = useNavigate();
  const bulkActions = useThreadBulkActions({
    onDeleted: (failedKeys) => {
      if (failedKeys.length === 0) navigate({ to: '/manage/threads' });
    }
  });
  const { requestDelete } = bulkActions;

  return (
    <>
      <ThreadDetailView
        detail={detail}
        variant="manage"
        extraActions={
          thread && (
            <>
              <Button
                icon={thread.hidden ? <EyeOutlined /> : <EyeInvisibleOutlined />}
                loading={bulkActions.pendingKeys.length > 0}
                onClick={() => bulkActions.toggleHidden(thread.hidden ? 'hidden' : 'active', [threadKey])}>
                {thread.hidden ? t('threads.table.showAgain') : t('threads.table.hide')}
              </Button>
              {requestDelete && (
                <Button danger icon={<DeleteOutlined />} onClick={() => requestDelete([threadKey])}>
                  {t('threads.table.delete')}
                </Button>
              )}
            </>
          )
        }
      />
      {thread && <DeleteEntityModal {...bulkActions.deleteModalProps} />}
    </>
  );
}
